import { render, staticRenderFns } from "./CountryHero.vue?vue&type=template&id=661387c8&scoped=true"
import script from "./CountryHero.vue?vue&type=script&lang=js"
export * from "./CountryHero.vue?vue&type=script&lang=js"
import style0 from "./CountryHero.vue?vue&type=style&index=0&id=661387c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "661387c8",
  null
  
)

export default component.exports